import {make} from "vuex-pathify";
import Vue from "vue";

export const BaseRestMutations = (state) => {
    return {
        ...make.mutations(state),
        pushItem(state, item) {
            state.items.push(item)
        },
        removeItem(state, id) {
            const idx = state.items.findIndex(item => item.id === id)
            state.items.splice(idx, 1)
        },
        updateItem(state, item) {
            const idx = state.items.findIndex(o => o.id === item.id)
            Vue.set(state.items, idx, item)
        }
    }
}
export default BaseRestMutations
